.header-wrapper {
  background-color: var(--default--background-color--1);
  color: var(--default--text-color--18);
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
  padding: var(--space-8) var(--space-16);
  font-size: 14px;
  line-height: 24px;
  border-bottom: 1px solid var(--default--border-color--12);
  gap: var(--space-8);
}

.title {
  display: flex;
  align-items: center;
  gap: var(--space-8);
}

.close-wrapper {
  display: flex;
  gap: var(--space-16);
  align-items: center;
}
